module.exports = __webpack_public_path__ + "img/buy_cart.8181bc7d.svg";